var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "feesForStopMasterForm",
      staticClass: "fees-for-stop-master-form",
      attrs: {
        model: _vm.model,
        rules: _vm.rules,
        "label-width": "auto",
        "label-position": "left"
      }
    },
    [
      _c(
        "div",
        { staticClass: "el-form--inline" },
        [
          _c("ChargeYear", {
            attrs: {
              label: "料金年度",
              prop: "charge_year",
              yearType: "reference",
              required: true,
              searchCond: true,
              disabled: _vm.editMode,
              autofocus: !_vm.editMode,
              initialize: true,
              tableType: _vm.tableType,
              mode: "this"
            },
            model: {
              value: _vm.chargeYear,
              callback: function($$v) {
                _vm.chargeYear = $$v
              },
              expression: "chargeYear"
            }
          }),
          _c("Select", {
            attrs: {
              label: "線別",
              prop: "route_code",
              required: !_vm.searchMode,
              searchCond: _vm.searchMode,
              disabled: _vm.editMode,
              codeId: "ROUTE_CODE",
              initialize: true
            },
            model: {
              value: _vm.routeCode,
              callback: function($$v) {
                _vm.routeCode = $$v
              },
              expression: "routeCode"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "el-form--inline" },
        [
          _c("Numeric", {
            attrs: {
              label: "最小データ",
              prop: "min_weight",
              required: !_vm.searchMode,
              searchCond: _vm.searchMode,
              min: 0,
              max: 9999,
              step: 1,
              disabled: _vm.editMode
            },
            model: {
              value: _vm.minWeight,
              callback: function($$v) {
                _vm.minWeight = $$v
              },
              expression: "minWeight"
            }
          }),
          _c("Numeric", {
            attrs: {
              label: "最大データ",
              prop: "max_weight",
              required: !_vm.searchMode,
              searchCond: _vm.searchMode,
              min: 0,
              max: 9999,
              step: 1,
              disabled: _vm.editMode
            },
            model: {
              value: _vm.maxWeight,
              callback: function($$v) {
                _vm.maxWeight = $$v
              },
              expression: "maxWeight"
            }
          })
        ],
        1
      ),
      _vm._l(_vm.tableComponents, function(tableComponent, form_index) {
        return [
          _c("el-divider", { key: "el-divider_" + String(form_index) }),
          _c(
            "div",
            {
              key: "div1_" + String(form_index),
              staticClass: "el-form--inline"
            },
            [
              _c("div", { key: "div2_" + String(form_index) }, [
                _vm._v(_vm._s(tableComponent.label))
              ])
            ]
          ),
          _c("Table", {
            key: "table_" + String(form_index),
            attrs: {
              "table-data": _vm.getModelItem(tableComponent.tableDataName)
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "columns",
                  fn: function() {
                    return [
                      _vm._l(
                        _vm.tableColumns(tableComponent.category),
                        function(tableColumn, index) {
                          return [
                            tableColumn.component == "MenuColumn"
                              ? _c("MenuColumn", {
                                  key: index,
                                  attrs: { cbdelete: _vm.deleteRow },
                                  on: { copy: _vm.copyRow }
                                })
                              : tableColumn.component == "TextColumn"
                              ? _c(tableColumn.component, {
                                  key: index,
                                  tag: "component",
                                  attrs: {
                                    prop: tableColumn.prop,
                                    label: tableColumn.label,
                                    editable: tableColumn.editable,
                                    width: tableColumn.width,
                                    maxlength: tableColumn.maxlength,
                                    required: tableColumn.required,
                                    placeholder: tableColumn.placeholder,
                                    disabled: tableColumn.disabled,
                                    uppercase: tableColumn.uppercase,
                                    tableDataName: tableComponent.tableDataName
                                  },
                                  model: {
                                    value: _vm.inputItemList(
                                      tableComponent.category
                                    )[tableColumn.prop],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.inputItemList(
                                          tableComponent.category
                                        ),
                                        tableColumn.prop,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "inputItemList(tableComponent.category)[tableColumn.prop]"
                                  }
                                })
                              : tableColumn.component == "NumericColumn"
                              ? _c(tableColumn.component, {
                                  key: index,
                                  tag: "component",
                                  attrs: {
                                    prop: tableColumn.prop,
                                    label: tableColumn.label,
                                    editable: tableColumn.editable,
                                    width: tableColumn.width,
                                    maxlength: tableColumn.maxlength,
                                    required: tableColumn.required,
                                    placeholder: tableColumn.placeholder,
                                    disabled: tableColumn.disabled,
                                    min: tableColumn.min,
                                    max: tableColumn.max,
                                    precision: tableColumn.precision,
                                    step: tableColumn.step,
                                    controls: tableColumn.controls,
                                    tableDataName: tableComponent.tableDataName
                                  },
                                  model: {
                                    value: _vm.inputItemList(
                                      tableComponent.category
                                    )[tableColumn.prop],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.inputItemList(
                                          tableComponent.category
                                        ),
                                        tableColumn.prop,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "inputItemList(tableComponent.category)[tableColumn.prop]"
                                  }
                                })
                              : tableColumn.component == "CodeColumn"
                              ? _c(tableColumn.component, {
                                  key: index,
                                  tag: "component",
                                  attrs: {
                                    prop: tableColumn.prop,
                                    label: tableColumn.label,
                                    editable: tableColumn.editable,
                                    width: tableColumn.width,
                                    required: tableColumn.required,
                                    placeholder: tableColumn.placeholder,
                                    disabled: tableColumn.disabled,
                                    initialize: tableColumn.initialize,
                                    tableDataName: tableComponent.tableDataName,
                                    codeId: tableColumn.codeId
                                  },
                                  model: {
                                    value: _vm.inputItemList(
                                      tableComponent.category
                                    )[tableColumn.prop],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.inputItemList(
                                          tableComponent.category
                                        ),
                                        tableColumn.prop,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "inputItemList(tableComponent.category)[tableColumn.prop]"
                                  }
                                })
                              : tableColumn.component == "CheckBoxColumn"
                              ? _c(tableColumn.component, {
                                  key: index,
                                  tag: "component",
                                  attrs: {
                                    prop: tableColumn.prop,
                                    label: tableColumn.label,
                                    width: tableColumn.width,
                                    disabled: tableColumn.disabled,
                                    tableDataName: tableComponent.tableDataName
                                  },
                                  model: {
                                    value: _vm.inputItemList(
                                      tableComponent.category
                                    )[tableColumn.prop],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.inputItemList(
                                          tableComponent.category
                                        ),
                                        tableColumn.prop,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "inputItemList(tableComponent.category)[tableColumn.prop]"
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        ]
      }),
      _vm.formMode === "edit"
        ? [
            _c("el-divider"),
            _c(
              "div",
              { staticClass: "el-form--inline" },
              [
                _c("DateTime", {
                  attrs: {
                    label: "更新日時",
                    prop: "updated_on",
                    required: !_vm.searchMode,
                    searchCond: _vm.searchMode,
                    disabled: _vm.editMode,
                    format: "yyyy/MM/dd HH:mm:ss"
                  },
                  model: {
                    value: _vm.updatedOn,
                    callback: function($$v) {
                      _vm.updatedOn = $$v
                    },
                    expression: "updatedOn"
                  }
                }),
                _c("Blank")
              ],
              1
            )
          ]
        : _vm._e(),
      _c("el-divider")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }